import * as constants from 'redux/constants/contactSettings.constants';
import * as systemConstants from 'redux/constants/systemStatus.constants';
import { IContactSettingsState } from 'types/contactSettings.types';
import { Reducer } from 'redux';

export const initialState: IContactSettingsState = {
  item: null,
  loading: false,
  error: null,
  success: false,
  successMessage: null,
};

const settingsReducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SETTINGS_ON_GET_CONTACT_REQUESTED:
    case constants.SETTINGS_ON_SAVE_CONTACT_REQUESTED:
      return { ...state, loading: true };
    case constants.SEND_CONTACT_EMAIL_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case constants.SEND_CONTACT_EMAIL_SUCCEEDED:
      return { ...state, loading: false, success: true };
    case systemConstants.GET_SYSTEM_STATUS_SUCCEEDED:
      return {
        ...state,
        item: action.data?.contactSettings,
        loading: false,
        error: null,
      };
    case constants.SETTINGS_ON_GET_CONTACT_SUCCEEDED:
    case constants.SETTINGS_ON_SAVE_CONTACT_SUCCEEDED:
      return {
        ...state,
        item: action.data?.item,
        loading: false,
        successMessage: action.data?.message || 'Consulta enviada con éxito',
      };
    case constants.SEND_CONTACT_EMAIL_FAILED:
      return { ...state, loading: false, error: action.payload };
    case constants.SETTINGS_ON_GET_CONTACT_FAILED:
    case constants.SETTINGS_ON_SAVE_CONTACT_FAILED:
      return { ...state, loading: false, error: action.error };
    case constants.RESET_CONTACT_STATUS:
      return initialState;
    default:
      return state;
  }
};

export default settingsReducer;
